module.exports = __webpack_public_path__ + "media/bootstrap-icons/diagram-3-4ec40fde.svg";